import { Injectable } from '@visiba/instantiation';
import { EventEmitter } from '@visiba/std';

@Injectable()
export class CaseCommunicator extends EventEmitter<{
	removeAppointment: string;
}> {
	constructor() {
		super();
	}

	public removeAppointmentCase(id: string) {
		// this.caseCommunicator.removeCase(this);

		this.emit('removeAppointment', id);
	}
}
